module.exports = __webpack_public_path__ + "static/media/oracle.806b35e0.svg";